import { createCrud } from '../../CRUD';
import { TVendorSecret } from './types';

export const vendorSecretBaseModel = createCrud<TVendorSecret>('vendorsecrets');
